import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "PowerSleep.svg",
  "use": "PowerSleep.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"PowerSleep.svg\"><path d=\"M32.0106,56.0208a24,24,0,1,1,24-24A24,24,0,0,1,32.0106,56.0208Zm0-4a19.9476,19.9476,0,0,0,15.9726-8H16.0376A19.9478,19.9478,0,0,0,32.0106,52.0208Zm0-40a19.99,19.99,0,0,0-18.3248,28H50.335a19.989,19.989,0,0,0-18.3244-28Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol